
import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator';
import Countdown from '~/mixins/Countdown';
import { getDateFormatsFromLocale, SupportedLocales } from '~/utils/locales';

@Component
export default class PriceChangeCountdown extends mixins(Countdown) {
  @Prop(Number) readonly priceChangeTime!: number;
  @Prop(String) readonly title!: string;

  get shouldShowCountdown() {
    return this.countdownEndTime && this.isCountdownEndTimeInFuture;
  }

  get priceName() {
    return (
      this.title || this.$t('components.films.priceChangeCountdown.priceName')
    );
  }

  @Watch('priceChangeTime', { immediate: true })
  handleTimeChange(current: number | undefined, previous: number | undefined) {
    if (current && current !== previous) {
      if (!this.countdownFormatOptions) {
        this.countdownFormatOptions = {
          format: ['days', 'hours', 'minutes', 'seconds'],
          locale: getDateFormatsFromLocale(
            this.$i18n.locale as SupportedLocales,
            true,
          ),
          zero: true,
        };
      }
      this.countdownEndTime = current;
    }
  }
}
